var React = require('react');

function ArrowInCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.75 40.1538C4.13462 36.4282 0 29.2529 0 21.5258C0 13.9365 4.13462 6.7613 10.75 2.8977C17.3654 -0.9659 25.6346 -0.9659 32.25 2.8977C38.8654 6.7613 43 13.7986 43 21.5258C43 29.115 38.8654 36.2902 32.25 40.1538C25.6346 44.0174 17.3654 43.8794 10.75 40.1538ZM31.5609 38.9119C37.7628 35.3243 41.6218 28.701 41.6218 21.5258C41.6218 14.3505 37.7628 7.72719 31.5609 4.13957C25.359 0.551941 17.641 0.551941 11.4391 4.13957C5.23718 7.72719 1.3782 14.3505 1.3782 21.5258C1.3782 28.701 5.23718 35.3243 11.4391 38.9119C17.641 42.4996 25.359 42.4996 31.5609 38.9119Z","key":0}),React.createElement("path",{"d":"M30 23.8525L21.6349 15H21.3651L13 24H15.9683L21.5 17.9508L27.0317 24L30 23.8525Z","key":1})]);
}

ArrowInCircle.defaultProps = {"viewBox":"0 0 43 43","fill":"none"};

module.exports = ArrowInCircle;

ArrowInCircle.default = ArrowInCircle;
